import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import 'flickity-imagesloaded';
import ProductCard from '../components/product-card';

export default register('product-recommendations', {
  onLoad() {
    const loadProductRecommendationsIntoSection = function () {
      // Look for an element with class 'product-recommendations'
      const productRecommendationsSection = document.querySelector('.product-recommendations');
      if (productRecommendationsSection === null) {
        return;
      }
      // Read product id from data attribute
      const productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      const limit = productRecommendationsSection.dataset.limit;
      // Build request URL
      const rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;
      const requestUrl = `${rootUrl}/recommendations/products?section_id=product-recommendations&limit=${limit}&product_id=${productId}`;
      // Create request and submit it using Ajax
      const request = new XMLHttpRequest();
      request.open('GET', requestUrl);
      request.onload = function () {
        if (request.status < 200 && request.status > 299) {
          return;
        }
        const container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML =
          container.querySelector('.product-recommendations').innerHTML;

        const productRecommendationsSlider = document.querySelector('.product-recommendations__slider');
        if (productRecommendationsSlider) {
          const thisPreviousButton = document.querySelector(
            '.product-recommendations__slider-controls .btn--control-prev'
          );
          const thisNextButton = document.querySelector('.product-recommendations__slider-controls .btn--control-next');
          const carouselStatus = document.querySelector('.product-recommendations__slider-controls .carousel-status');

          const thisSlider = new Flickity(productRecommendationsSlider, {
            // options
            freeScroll: false,
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            setGallerySize: true,
            cellAlign: 'left',
            watchCSS: true,
            wrapAround: false,
            on: {
              change() {
                if (!thisSlider.slides[thisSlider.selectedIndex - 1]) {
                  thisPreviousButton.setAttribute('disabled', 'disabled');
                  thisNextButton.removeAttribute('disabled');
                  // eslint-disable-next-line no-negated-condition
                } else if (!thisSlider.slides[thisSlider.selectedIndex + 1]) {
                  thisPreviousButton.removeAttribute('disabled');
                  thisNextButton.setAttribute('disabled', 'disabled');
                } else {
                  thisPreviousButton.removeAttribute('disabled');
                  thisNextButton.removeAttribute('disabled');
                }
              },
            },
          });

          if (thisPreviousButton) {
            thisPreviousButton.addEventListener('click', function () {
              thisSlider.previous();
            });
            thisNextButton.addEventListener('click', function () {
              thisSlider.next();
            });
          }

          // eslint-disable-next-line no-inner-declarations
          function updateStatus() {
            let slideNumber = thisSlider.selectedIndex + 1;
            if (thisSlider.slides.length - 1 === slideNumber) {
              slideNumber = thisSlider.slides.length;
            }
            carouselStatus.textContent = `0${slideNumber} / ${thisSlider.slides.length < 10 ? '0' : ''}${
              thisSlider.slides.length
            }`;
          }

          updateStatus();
          thisSlider.on('select', updateStatus);
          const productCards = productRecommendationsSlider.querySelectorAll('.product-card');
          if (productCards && productCards.length > 0) {
            productCards.forEach((product) => ProductCard(product));
          }
        }
      };
      request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId === 'product-recommendations') {
        loadProductRecommendationsIntoSection();
      }
    });
    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();
  },
});
